/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconMegaphone = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 140 140"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 140px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M39.375 88.958H26.25a21.875 21.875 0 0 1 0-43.75h13.125zM39.375 88.958a130.083 130.083 0 0 1 72.135 21.84l6.615 4.41v-96.25l-6.615 4.41a130.083 130.083 0 0 1-72.135 21.84zM135.625 58.333v17.5M39.375 88.958A42.227 42.227 0 0 0 52.5 119.583"
        />
      </g>
    </svg>
  ),
);
